import { AiOutlineUpload, AiOutlineCloseSquare, AiOutlineSearch, AiOutlineCheckSquare, AiOutlineEdit } from "react-icons/ai";

import RowComponent from "./RowComponent";
import { RiAddCircleLine } from "react-icons/ri";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import useAuth from "../../authentication/useAuth";
import toast, { Toaster } from "react-hot-toast";
import AddModal from "./AddModal";
import moment from "jalali-moment";

import { digitsFaToEn } from "@persian-tools/persian-tools";

export default function ContractList() {
  const [contract, setContract] = useState();
  const [filteredContract, setFilteredContract] = useState([]);
  const { UserInfo } = useAuth();
  const [searchValue, setSearchValue] = useState();
  const [updater, setUpdater] = useState(false);

  useEffect(() => {
    let fd = new FormData();
    fd.append("token", UserInfo.user_token);
    let a = axios.post("http://smarteca.ir/amlak/?action=listagent", fd);
    a.then(({ data }) => {
      if (data.state == 1) {
        setContract(data.result.reverse());
        setFilteredContract(data.result);
      } else {
      }
    });
  }, [UserInfo, updater]);

  function addEditContract(e, type, index) {
    e.preventDefault();
    let fd = new FormData(e.target);
    fd.append("token", UserInfo.user_token);
    switch (type) {
      case "add":
        if (fd.has("amlak_state")) {
          fd.set("amlak_state", 1);
        } else {
          fd.append("amlak_state", 0);
        }

        if (fd.has("amlak_subscription_state")) {
          fd.set("amlak_subscription_state", 1);
        } else {
          fd.append("amlak_subscription_state", 0);
        }
        if (fd.has("expire_date")) {
          fd.set("expire_date", Date.parse(moment.from(digitsFaToEn(fd.get("expire_date")), "fa", "YYYY/MM/DD").format("YYYY/MM/DD")) / 1000);
        }
        break;
      case "edit":
        if (fd.has("agency_state")) {
          fd.set("agency_state", 1);
        } else {
          fd.append("agency_state", 0);
        }

        if (fd.has("subscribtion_state")) {
          fd.set("subscribtion_state", 1);
        } else {
          fd.append("subscribtion_state", 0);
        }
        if (fd.has("expiredate")) {
          fd.set("expiredate", Date.parse(moment.from(digitsFaToEn(fd.get("expiredate")), "fa", "YYYY/MM/DD").format("YYYY/MM/DD")) / 1000);
        }
        break;
      default:
        break;
    }

    let a = axios.post(`http://smarteca.ir/amlak/?action=${type}`, fd);
    a.then(({ data }) => {
      if (data.state == 1) {
        toast.success("قرارداد با موفقیت ذخیره شد !");
        setUpdater(!updater);
        if (type == "add") {
          document.querySelector("#close-add-modal").click();
        } else if (type == "edit") {
          document.querySelector(`#edit-contract-${index}`).click();
        }
      } else {
        toast.error("مشکلی به وجود آمده!");
      }
    });
  }
  function search(e) {
    setSearchValue(e.target.value);

    if (e.target.value != "") {
      let res = contract.filter((value1, index) => {
        for (let key in value1) {
          if (value1[key].toString().includes(e.target.value)) {
            return true;
          }
        }
        return false;
      });
      setFilteredContract([...res]);
    } else {
      setFilteredContract([...contract]);
    }
  }
  return (
    <>
      <div className="contract-list-container table-responsive">
        <h4 className="text-center">لیست قراداد ها</h4>
        <AddModal addEditContract={addEditContract}></AddModal>
        <div className="filter-section d-flex flex-wrap justify-content-evenly my-5">
          <button className="btn btn-primary " data-bs-toggle="modal" data-bs-target="#create-contract">
            <RiAddCircleLine style={{ fontSize: "20px", marginLeft: "5px" }}></RiAddCircleLine>
            افزودن
          </button>
          <div className="search mt-2">
            <input type="text" className="form-control " placeholder="جست و جو..." value={searchValue} onChange={search} />
            <div className="search-icon">
              <button className="btn">
                <AiOutlineSearch></AiOutlineSearch>
              </button>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover table-bordered text-center">
            <thead className="table-primary">
              <tr>
                <th scope="col">#</th>

                <th scope="col">کد صنفی</th>
                <th scope="col"> نام</th>
                <th scope="col">نام املاک</th>
                <th scope="col">تلفن املاک</th>

                <th scope="col">موبایل املاک</th>
                <th scope="col">موبایل </th>
                <th scope="col">تاریخ پایان</th>
                <th scope="col">تاریخ ثبت نام</th>

                <th scope="col">تعداد درخواست پیامک</th>
                <th scope="col">وضعیت املاک</th>
                <th scope="col">وضعیت اشتراک</th>
                <th scope="col">تاریخ آخرین پیامک</th>
                <th scope="col">عملیات</th>
              </tr>
            </thead>
            <tbody>
              {filteredContract?.map((value, index) => {
                return <RowComponent index={index} addEditContract={addEditContract} contract={value}></RowComponent>;
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
